import { Box } from '@mui/material';
import React from 'react';
import Plot from 'react-plotly.js';
import { basePlotConfig, useChartTheme } from '../overview/plotTheme';

const HourlyPlot = ({
  tsCharge,
  tsDischarge,
  tsTemperature,
}) => {
  const hasTemperature = tsTemperature?.y?.some((v) => v != null);
  const { colors, baseLayout: makeLayout, themeTrace } = useChartTheme();
  const baseLayout = makeLayout("Energy (kWh)");

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Plot
        data={(hasTemperature
          ? [tsCharge, tsDischarge, tsTemperature]
          : [tsCharge, tsDischarge]).map(themeTrace)}
        layout={{
          ...baseLayout,
          legend: { ...baseLayout.legend, x: 0, xanchor: "left" },
          yaxis2: {
            title: { text: "Max ambient temp. (°C)", font: { size: 12, color: colors.text }, standoff: 8 },
            overlaying: "y",
            side: "right",
            zeroline: false, // Avoid a second zero line when the two axes scale differently
            visible: hasTemperature,
            showgrid: false,
            automargin: true,
          },
        }}
        config={basePlotConfig}
        useResizeHandler={true}
        style={{ width: "100%", height: "100%" }}
      />
    </Box>
  )
}

export default HourlyPlot;
